module.exports = __webpack_public_path__ + "static/media/PIXEL-OP-32.4bbac0a0.png";